// Cor de fundo determinística por cliente (derivada do id) para o Planejamento Semanal.

export interface ClientColor {
  bg: string
  text: string
  border: string
}

const PALETTE: ClientColor[] = [
  { bg: 'bg-rose-100', text: 'text-rose-900', border: 'border-rose-200' },
  { bg: 'bg-amber-100', text: 'text-amber-900', border: 'border-amber-200' },
  { bg: 'bg-emerald-100', text: 'text-emerald-900', border: 'border-emerald-200' },
  { bg: 'bg-sky-100', text: 'text-sky-900', border: 'border-sky-200' },
  { bg: 'bg-violet-100', text: 'text-violet-900', border: 'border-violet-200' },
  { bg: 'bg-teal-100', text: 'text-teal-900', border: 'border-teal-200' },
  { bg: 'bg-orange-100', text: 'text-orange-900', border: 'border-orange-200' },
  { bg: 'bg-indigo-100', text: 'text-indigo-900', border: 'border-indigo-200' },
  { bg: 'bg-fuchsia-100', text: 'text-fuchsia-900', border: 'border-fuchsia-200' },
  { bg: 'bg-cyan-100', text: 'text-cyan-900', border: 'border-cyan-200' },
  { bg: 'bg-lime-100', text: 'text-lime-900', border: 'border-lime-200' },
]

export function clientColor(id: string): ClientColor {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]
}
